export function entitlementsDebug(...args) {
  void args;
  return;
}
